module.exports = __webpack_public_path__ + "img/time_over.879b40b0.png";